module.exports = __webpack_public_path__ + "static/media/pos_slideshow2.617e1545.jpg";